(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase();

  const vidaMediaColors = {
    'img-0495.png': 'black',
    'img-0498.png': 'black',
    'f633b3d0-3564-415d-9fda-861c468bf3ea.png': 'black',
    '1ced101e-9b0e-4754-a332-271f49053955.png': 'black',
    'img-0492.png': 'white',
    'img-0497.png': 'white',
    '41c9aef8-3eb3-49d0-9783-c1ed88a29f60.png': 'white',
    'dee1c2ba-38db-4af2-a3d7-7ee05add39a8.png': 'white',
  };

  const culturaMediaColors = {
    'img-0488.png': 'shadow',
    '8b0c28bb-d526-4a19-8bd1-c7e41bdc0e19.png': 'shadow',
    'img-0493.png': 'black',
    'img-7064.png': 'black',
    'img-0549.png': 'mocha',
    '2b11e6bd-561b-43ef-972a-0083bc6db94c.png': 'mocha',
  };

  const exactMediaColors = { ...vidaMediaColors, ...culturaMediaColors };

  const mediaColor = (image) => {
    const alt = image?.getAttribute('alt') || '';
    const match = alt.match(/(?:^|[|;])\s*color\s*:\s*([^|;]+)/i);
    if (match) return normalize(match[1]);

    const source = normalize(image?.currentSrc || image?.src).split('?')[0];
    const filename = source.split('/').pop();
    return exactMediaColors[filename] || '';
  };

  const selectedColor = (root) => {
    const selectors = root.querySelector('variant-selects');
    if (!selectors) return '';

    for (const select of selectors.querySelectorAll('select[name^="options["]')) {
      const name = select.getAttribute('name')?.match(/^options\[(.+)\]$/)?.[1];
      if (normalize(name) === 'color') return normalize(select.value);
    }

    for (const fieldset of selectors.querySelectorAll('fieldset')) {
      const legend = fieldset.querySelector('legend')?.textContent || '';
      if (normalize(legend.split(':')[0]) !== 'color') continue;
      return normalize(fieldset.querySelector('input:checked')?.value);
    }

    return '';
  };

  const filterGallery = (productInfo) => {
    const color = selectedColor(productInfo);
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery || !color) return;

    const slides = [...gallery.querySelectorAll('[id^="Slider-Gallery-"] > li[data-media-id]')];
    const taggedSlides = slides.filter((slide) => mediaColor(slide.querySelector('img')));

    // Leave standard Dawn behavior untouched until the merchant labels at least one image.
    if (!taggedSlides.length) return;

    slides.forEach((slide) => {
      const tag = mediaColor(slide.querySelector('img'));
      const visible = tag === color || tag === 'all';
      slide.classList.add('cr-color-filtered-media');
      slide.hidden = !visible;
      slide.setAttribute('aria-hidden', String(!visible));
    });

    const visibleSlides = slides.filter((slide) => !slide.hidden);
    // Never allow bad or incomplete media labels to leave the product gallery empty.
    if (!visibleSlides.length) {
      slides.forEach((slide) => {
        slide.hidden = false;
        slide.removeAttribute('aria-hidden');
      });
      return;
    }

    const thumbnails = [...gallery.querySelectorAll('[id^="Slider-Thumbnails-"] > li[data-target]')];
    const visibleIds = new Set(visibleSlides.map((slide) => slide.dataset.mediaId));
    thumbnails.forEach((thumbnail) => {
      const visible = visibleIds.has(thumbnail.dataset.target);
      thumbnail.hidden = !visible;
      thumbnail.setAttribute('aria-hidden', String(!visible));
    });

    const current = gallery.querySelector('.slider-counter--current');
    const total = gallery.querySelector('.slider-counter--total');
    if (current) current.textContent = '1';
    if (total) total.textContent = String(visibleSlides.length);

    gallery.setActiveMedia?.(visibleSlides[0].dataset.mediaId, false);
    gallery.querySelector('[id^="GalleryViewer-"]')?.resetPages?.();
    gallery.querySelector('[id^="GalleryThumbnails-"]')?.resetPages?.();

    const sectionId = productInfo.dataset.section;
    const modal = document.querySelector(`#ProductModal-${CSS.escape(sectionId)}`);
    if (modal) {
      const modalMedia = [...modal.querySelectorAll('.product-media-modal__content > *')];
      const taggedModalMedia = modalMedia.filter((item) =>
        mediaColor(item.matches('img') ? item : item.querySelector('img'))
      );
      if (taggedModalMedia.length) {
        modalMedia.forEach((item) => {
          const image = item.matches('img') ? item : item.querySelector('img');
          const tag = mediaColor(image);
          item.hidden = !(tag === color || tag === 'all');
        });
      }
    }

    const status = gallery.querySelector('[id^="GalleryStatus-"]');
    if (status) status.textContent = `${visibleSlides.length} images available for ${color}.`;
  };

  const filterAll = () => {
    document.querySelectorAll('product-info').forEach(filterGallery);
  };

  document.addEventListener('DOMContentLoaded', filterAll);
  document.addEventListener('shopify:section:load', filterAll);
  document.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects')) return;
    window.setTimeout(() => {
      const productInfo = event.target.closest('product-info');
      if (productInfo) filterGallery(productInfo);
    }, 250);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(filterAll, 0));
  }

})();
